import { createContext } from 'react';

type SortableRowContextType = {
  handleRef: (node: HTMLElement | null) => void;
} | null;

export const SortableRowContext = createContext<SortableRowContextType>(null);
